module.exports = __webpack_public_path__ + "img/index2.f09e4cee.png";